export enum SedsPositionsOptions {
  BOTTOM = 'bottom',
  CENTER = 'center',
  END = 'end',
  LEFT = 'left',
  RIGHT = 'right',
  START = 'start',
  TOP = 'top',
  ABOVE = 'above',
  BELOW = 'below',
}
